// extracted by mini-css-extract-plugin
export default {"Container":"ViewAsAdminButton_Container__-Chug","AdminButton":"ViewAsAdminButton_AdminButton__c7F6h","TooltipContainer":"ViewAsAdminButton_TooltipContainer__f7QdS"};